import { render } from "./TheGlobalHeader.vue?vue&type=template&id=3fbfa6c2&scoped=true&ts=true"
import script from "./TheGlobalHeader.vue?vue&type=script&lang=ts"
export * from "./TheGlobalHeader.vue?vue&type=script&lang=ts"

import "./TheGlobalHeader.vue?vue&type=style&index=0&id=3fbfa6c2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbfa6c2"]])

export default __exports__